import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 診療科一覧
 *
 * 診療科データの一覧を返す
 */
export class FetchDepartment implements APIRequest<Monitaro.FetchDepartmentResponse> {
  response: Monitaro.FetchDepartmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/departments`
  }
}

/**
 * 診療科データの取得
 *
 * 指定されたIDの診療科情報を返す
 */
export class GetDepartment implements APIRequest<Monitaro.GetDepartmentResponse> {
  response: Monitaro.GetDepartmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(department: string) {
    this.path = `/departments/${department}`
  }
}
